const jobPage = (ScrollTrigger, smoother) => {
  var jobContainer = $('.job-posting'), // Single job container
      $scrollBtn = $('.job-title a'),
      query = document.location.search, // Get the Greenhouse URL query and Id of the selected job
      query = query.replace('?gh_jid=', ''), // Pull the Greenhouse Id of the selected job from the URL query
      jobPost = 'https://boards-api.greenhouse.io/v1/boards/videoamp/jobs/' + query; // Create API link for the selected job
  
  if ($scrollBtn.length) {
    $scrollBtn.on('click', function(e) {
      e.preventDefault();
      smoother.scrollTo($('#grnhse_app'), true, "top 100px");
    });
  }    
      
  if (jobContainer.length) {
    // Get job info
    $.ajax({
      url: jobPost,
      type: 'GET',
      success: function(data) {

        // $(document).prop('title', 'Job openings - ' + data.title);
        // $("meta[property='og\\:title']").attr("content", 'Job openings - ' + data.title);
        // $("meta[property='og\\:url']").attr("content", data.absolute_url);

        $('.job-posting').css('opacity', 1); // Show container

        var jobDepartments = data.departments, // Get the departments for the current job and create an empty array for the results
            deptartmentItems = new Array();

        // Loop through the departments and push them to an array
        $.each(jobDepartments, function(key,value) {
          deptartmentItems.push(value.name);
        });

        var departmentList = deptartmentItems.join(', '), // Create variable for secondary label when there is more than one department
            jobLocation = $('.jobs-location p'),
            jobDepartment = $('.job-dept'),
            jobTitle = $('.job-title h1');

        jobLocation.html(data.location.name);
        jobDepartment.html(departmentList);
        jobTitle.html(data.title);

        var jobDescription = data.content; // Get the innerHTML of the job content
        $('.job-description').html( // Append it to the page
          $('<div/>', { // create an element where the html content as the string
            html: jobDescription
          }).text() // get text content from element for decoded text
        );

        // Load Greenhouse embed form
        var url = "https://boards.greenhouse.io/embed/job_board/js?for=videoamp";

        $.getScript({
          url: url,
          success: function() {

            //overrides has a callback. Need to pass on load callback to overrides so that it gets applied to Grnhse

            $('.gform_ajax_spinner').fadeOut(300, function() {

              Grnhse.Iframe.load(query);

              // Delayed call to ScrollTrigger Refresh to account for the iframe loading
              setTimeout(() => {
                ScrollTrigger.refresh();
              }, "1000");
              
            });

          },
        });

      }
    });
  }
  
}

export {
  jobPage
};
